import { Injectable } from '@angular/core';
import {AppConfig} from '../app.config';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
private createCategoryUrl = this.config.baseUrl + 'api/category';
private getCategoryDetailsUrl = this.config.baseUrl + 'api/category/';
private getListOfUsersCategoryUrl = this.config.baseUrl + 'api/category/';
private deleteCategoryUrl = this.config.baseUrl + 'api/category/';
private syncCategoryUrl = this.config.baseUrl + 'api/sync/categories';
private categoryDetailUrl = this.config.baseUrl + 'api/category/id';
  constructor(private config: AppConfig,
              private http: HttpClient) { }
   createCategory(category): Observable<any>{
    return this.http.post(this.createCategoryUrl, category,
      {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token'),
          Content_Language: localStorage.getItem('trans')
        },
      }).pipe(map((response: Response) => {
      return response;
    }));
   }
  getCategoryDetails(id): Observable<any>{
  return this.http.get<any>(this.getCategoryDetailsUrl + id, {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
      Content_Language: localStorage.getItem('trans')
    },
  }).pipe(map((response: Response) => {
    return response;
  }));
  }
  getListOfUsersCategory(): Observable<any>{
    return this.http.get(this.getListOfUsersCategoryUrl, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        Content_Language: localStorage.getItem('trans')
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  deleteFromCategory(id): Observable<any>{
    return this.http.delete(this.deleteCategoryUrl + id, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
  syncCategory(cats): Observable<any>{
    return this.http.post(this.syncCategoryUrl, {
      categories: cats
    }, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    }).pipe(map((response: Response) => {
      return response;
    }));
  }
}
